/**
 * 路由守卫组件
 * 登录页已移除，当前直接放行所有页面
 */

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    return <>{children}</>
}

export default ProtectedRoute
